import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ErrorPage from "@/pages/ErrorPage";

export function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A]">
        <div className="flex flex-col items-center gap-4" data-testid="auth-loading">
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-white/10 border-t-[#E30613]" />
          <p className="text-sm text-neutral-500">Loading SGBINOXE Care…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.role === "installer" && user.status !== "active") {
    return <Navigate to="/pending-approval" replace />;
  }

  if (requireAdmin && user.role !== "super_admin") {
    return <ErrorPage code={403} />;
  }

  return children;
}
